import React, { useEffect, useState } from 'react';
import { RiErrorWarningLine } from 'react-icons/ri';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { useMutation, useQuery } from 'react-query';
import { LanguageContext } from '../../../LanguageContext';
import { ThemeContext } from '../../../ThemeContext';
import { fetchuseauthorization, logincheck } from '../../API/Login_API';
import tabexlogo from '../Generalfiles/images/tabexlogo.png';
import styles from './login.module.css';

import Buttonpreloader from '../Buttonpreloader';

const Login = () => {
    useQuery(['fetchuseauthorization'], () => fetchuseauthorization(), { keepPreviousData: true, staleTime: 500000000000000000 });

    const { lang, langdetect } = React.useContext(LanguageContext);
    const { setThemeOverride } = React.useContext(ThemeContext);
    const [logininputs, setlogininputs] = useState({
        email: '',
        password: '',
        loginstatus: true,
    });
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        setThemeOverride('light');
        return () => setThemeOverride(null);
    }, [setThemeOverride]);

    const logincheckMutation = useMutation('logincheck', {
        mutationFn: logincheck,
        onMutate: () => {},
        onError: () => {},
        onSuccess: (data) => {
            var logininputstemp = { ...logininputs };
            logininputstemp.loginstatus = data.data.loggedin;
            setlogininputs({ ...logininputstemp });
            if (data.data.loggedin) {
                window.location.reload();
            }
        },
    });

    const handleLogin = () => {
        if (logininputs.email.length !== 0 && logininputs.password.length !== 0) {
            logincheckMutation.mutate({
                email: logininputs.email,
                password: logininputs.password,
            });
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleLogin();
        }
    };

    const isRtl = langdetect !== 'en';

    return (
        <div className={styles.loginRoot} dir={isRtl ? 'rtl' : 'ltr'}>
            <div className={styles.scene} aria-hidden="true">
                <div className={styles.sceneGlow} />
                <div className={styles.sceneGlowAlt} />
                <div className={styles.orbitRing} />
                <div className={styles.orbitRingAlt} />

                <div className={`${styles.floatCard} ${styles.floatCardA}`}>
                    <span className={styles.floatLabel}>TABEX+</span>
                    <span className={styles.floatSub}>Series Studio</span>
                </div>
                <div className={`${styles.floatCard} ${styles.floatCardB}`}>
                    <span className={styles.floatLabelGold}>Build</span>
                    <span className={styles.floatSub}>websites that sell</span>
                </div>
                <div className={`${styles.floatCard} ${styles.floatCardC}`}>
                    <span className={styles.floatChip}>POS</span>
                    <span className={styles.floatChip}>Orders</span>
                    <span className={styles.floatChip}>Apps</span>
                </div>
                <div className={`${styles.floatCard} ${styles.floatCardD}`}>
                    <span className={styles.floatPlus}>+</span>
                    <span className={styles.floatSub}>Tabex Dashboard</span>
                </div>
                <div className={`${styles.floatCard} ${styles.floatCardE}`}>
                    <span className={styles.floatLabel}>Launch faster</span>
                    <span className={styles.floatSub}>with Tabex Series</span>
                </div>
                <div className={`${styles.floatCard} ${styles.floatCardF}`}>
                    <span className={styles.floatMark}>TX</span>
                </div>
                <div className={`${styles.floatCard} ${styles.floatCardG}`}>
                    <span className={styles.floatLabelGold}>Grow</span>
                    <span className={styles.floatSub}>your business</span>
                </div>
                <div className={`${styles.floatCard} ${styles.floatCardH}`}>
                    <span className={styles.floatLabel}>Analytics</span>
                    <span className={styles.floatSub}>live insights</span>
                </div>

                <span className={`${styles.orbitTag} ${styles.orbitTagA}`}>Tabex Series</span>
                <span className={`${styles.orbitTag} ${styles.orbitTagB}`}>Website Builder</span>
                <span className={`${styles.orbitTag} ${styles.orbitTagC}`}>One Studio</span>
                <span className={`${styles.orbitTag} ${styles.orbitTagD}`}>Mobile App</span>
                <span className={`${styles.orbitTag} ${styles.orbitTagE}`}>Smart POS</span>

                <div className={`${styles.sweepPill} ${styles.sweepPillA}`}>TABEX SERIES</div>
                <div className={`${styles.sweepPill} ${styles.sweepPillB}`}>BUILD • LAUNCH • GROW</div>
                <div className={`${styles.sweepPill} ${styles.sweepPillC}`}>YOUR STORE ONLINE</div>

                <div className={styles.marquee}>
                    <div className={styles.marqueeTrack}>
                        <span>Tabex Series</span>
                        <span>Website Builder</span>
                        <span>Mobile Apps</span>
                        <span>POS</span>
                        <span>Analytics</span>
                        <span>Tabex Series</span>
                        <span>Website Builder</span>
                        <span>Mobile Apps</span>
                        <span>POS</span>
                        <span>Analytics</span>
                    </div>
                </div>
                <div className={`${styles.marquee} ${styles.marqueeTop}`}>
                    <div className={`${styles.marqueeTrack} ${styles.marqueeTrackReverse}`}>
                        <span>Dashboard</span>
                        <span>Orders</span>
                        <span>Products</span>
                        <span>Customers</span>
                        <span>Reports</span>
                        <span>Dashboard</span>
                        <span>Orders</span>
                        <span>Products</span>
                        <span>Customers</span>
                        <span>Reports</span>
                    </div>
                </div>
            </div>

            <div className={styles.frame}>
                <aside className={styles.brandPane}>
                    <div className={styles.brandTop}>
                        <div className={styles.logoChip}>
                            <img src={tabexlogo} alt="Tabex Series" />
                        </div>
                    </div>

                    <div className={styles.brandMid}>
                        <p className={styles.eyebrow}>{isRtl ? 'منصة بناء المواقع' : 'Website builder platform'}</p>
                        <h1 className={styles.headline}>
                            {lang.yourmobileapp}
                            <br />
                            {isRtl ? 'و' : '&'} {lang.website}
                            <br />
                            <span>{lang.inoneplace}</span>
                        </h1>
                        <p className={styles.subcopy}>
                            {isRtl
                                ? 'ادخل لوحة التحكم لإدارة متجرك وموقعك وتطبيقك من مكان واحد.'
                                : 'Step into your workspace to manage your store, website, and app from one place.'}
                        </p>

                        <ul className={styles.featureList}>
                            <li>
                                <span className={styles.featureMark} />
                                {isRtl ? 'إدارة الطلبات والمنتجات' : 'Orders & product control'}
                            </li>
                            <li>
                                <span className={styles.featureMark} />
                                {isRtl ? 'تقارير ولوحة تحليلات' : 'Reports & live analytics'}
                            </li>
                            <li>
                                <span className={styles.featureMark} />
                                {isRtl ? 'موقع وتطبيق من استوديو واحد' : 'Site & app in one studio'}
                            </li>
                        </ul>
                    </div>

                    <div className={styles.brandBottom}>
                        <span className={styles.brandDot} />
                        <span>Tabex Series Dashboard</span>
                    </div>
                </aside>

                <main className={styles.formPane}>
                    <div className={styles.formInner}>
                        <div className={styles.mobileLogo}>
                            <div className={styles.logoChip}>
                                <img src={tabexlogo} alt="Tabex Series" />
                            </div>
                        </div>

                        <h2 className={styles.formTitle}>
                            {lang.welcomeback}
                            {lang.totabexseries}
                        </h2>
                        <p className={styles.formLead}>{isRtl ? 'سجّل الدخول للمتابعة إلى لوحة التحكم.' : 'Sign in to continue to your dashboard.'}</p>

                        <form
                            className={styles.form}
                            id="loginform"
                            onSubmit={(e) => {
                                e.preventDefault();
                                handleLogin();
                            }}
                        >
                            <div className={styles.field}>
                                <label htmlFor="email" className={styles.label}>
                                    {lang.email}
                                </label>
                                <div className={styles.inputWrap}>
                                    <input
                                        name="email"
                                        id="email"
                                        type="email"
                                        autoComplete="email"
                                        className={styles.input}
                                        placeholder={lang.email}
                                        value={logininputs.email}
                                        onKeyDown={handleKeyDown}
                                        onChange={(event) => {
                                            var logininputstemp = { ...logininputs };
                                            logininputstemp.email = event.target.value;
                                            setlogininputs({ ...logininputstemp });
                                        }}
                                    />
                                </div>
                            </div>

                            <div className={styles.field}>
                                <label htmlFor="password" className={styles.label}>
                                    {lang.password}
                                </label>
                                <div className={styles.inputWrap}>
                                    <input
                                        name="password"
                                        id="password"
                                        type={showPassword ? 'text' : 'password'}
                                        autoComplete="current-password"
                                        className={`${styles.input} ${styles.inputWithToggle}`}
                                        placeholder={lang.password}
                                        value={logininputs.password}
                                        onKeyDown={handleKeyDown}
                                        onChange={(event) => {
                                            var logininputstemp = { ...logininputs };
                                            logininputstemp.password = event.target.value;
                                            setlogininputs({ ...logininputstemp });
                                        }}
                                    />
                                    <button
                                        type="button"
                                        className={styles.togglePassword}
                                        onClick={() => setShowPassword((prev) => !prev)}
                                        aria-label={showPassword ? (isRtl ? 'إخفاء كلمة السر' : 'Hide password') : isRtl ? 'إظهار كلمة السر' : 'Show password'}
                                        aria-pressed={showPassword}
                                    >
                                        {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                                    </button>
                                </div>
                            </div>

                            {!logininputs.loginstatus && (
                                <p className={styles.error}>
                                    <RiErrorWarningLine size={17} />
                                    {lang.wrongemailorpassword}
                                </p>
                            )}

                            <button className={styles.submit} type="button" disabled={logincheckMutation.isLoading} onClick={handleLogin}>
                                <span className={logincheckMutation.isLoading ? styles.submitLabelHidden : styles.submitLabel}>{lang.login}</span>
                                <span className={logincheckMutation.isLoading ? styles.submitSpinner : styles.submitSpinnerHidden}>
                                    <Buttonpreloader variant="onDark" size={20} />
                                </span>
                            </button>
                        </form>

                        <p className={styles.secureNote}>{isRtl ? 'وصول آمن إلى مساحة عملك' : 'Secure access to your workspace'}</p>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default Login;
